import styled from '@emotion/styled'
import { useAtomValue } from 'jotai'
import { FC, useMemo } from 'react'
import { Shapes } from 'src/components/theme'
import { PARCEL_TYPES_MAP } from 'src/constants/cherre-data-dictionary/zoning-colors'
import { DonutChart } from 'src/v2/components/donut-chart'
import { Table } from 'src/v2/views/owner-reveal/insights/portfolio-summary/property-type-breakdown/table'
import { Title } from 'src/v2/views/owner-reveal/insights/portfolio-summary/property-type-breakdown/title'

import * as atoms from 'src/v2/state/owner-reveal/portfolio-summary'

const CHART_SIZE = 360

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-inline: ${Shapes.spacing[6]}px;
`

const Content = styled.div`
  display: flex;
  gap: 16px;

  flex-direction: column;

  @media (min-width: 1025px) {
    flex-direction: row;
  }
`

const ChartWrapper = styled.div`
  display: flex;
  width: ${CHART_SIZE}px;
`

export const Overview: FC = () => {
  const overview = useAtomValue(atoms.propertyTypesOverview)
  const total = useAtomValue(atoms.totalPropertiesCount)
  const chartData = useMemo(() => {
    if (!overview) {
      return []
    }
    return overview.map((item) => ({
      y: item.count,
      color: PARCEL_TYPES_MAP.get(item.propertyType)?.color ?? 'gray',
      name: PARCEL_TYPES_MAP.get(item.propertyType)?.label ?? 'Unknown',
    }))
  }, [overview])

  const tableData = useMemo(() => {
    if (!overview) {
      return []
    }
    return overview.map((item) => ({
      type: item.propertyType,
      value: item.count,
      percentage: item.percentage,
    }))
  }, [overview])

  return (
    <Container>
      <Title>Overview</Title>
      <Content>
        <ChartWrapper>
          <DonutChart
            height={CHART_SIZE}
            data={chartData}
            title={total || ''}
            subtitle="Properties"
            titleFontSize={48}
          />
        </ChartWrapper>
        <Table data={tableData} valueHeader="# of Properties" />
      </Content>
    </Container>
  )
}
